module.exports = __webpack_public_path__ + "static/media/objects2_19.989bb91f.svg";